import { SearchMatchType } from '@aibees/elephant/types';
import { capitalize } from '@aibees/shared/utils';
import {
  ClassificationGroups,
  ClassificationType,
  FilterCategory,
  SearchFilterBase,
  SearchFilterType,
} from '../types';

export default function productAndServicesyFilterConfig(): SearchFilterBase {
  return {
    id: 'Product & Services',
    name: 'Product & Services',
    icon: 'product-and-services',
    index: 24,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.COMPANY_DATA],
    pinned: true,
    sections: { main: 2, more: 1 },
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Service Tags',
        },
      },
    },
    items: [
      {
        name: 'Include',
        type: SearchFilterType.CUSTOM_SELECT,
        icon: undefined,
        index: 0,
        exactMatch: {
          enabled: true,
          default: SearchMatchType.WORD,
        },
        key: 'include_products_and_services',
        field: 'include_products_and_services',
        layer: 3,
        metadata: {
          color: 'primary',
          icon: 'add-circle-outline',
          preset: 'products_and_services',
          placeholder: 'Include Products & Services (OR) Search',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            allowCustomValuesByEnter: true,
          },
          advancedButtonVisible: true,
          dialog: {
            title: 'Bulk Include Product & Services',
            subTitleItemLabel: 'Product & Services',
            subTitleItemLabelPlural: 'Product & Services',
            icon: 'product-and-services',
            textArea: {
              placeholder:
                'Software Development, SaaS, Cloud Computing, Cybersecurity, ....',
            },
          },
        },
        open: true,
        utils: {
          tags: { labelFormatter: capitalize },
        },
        searchKey: 'value',
        config: { labelKey: 'value', valueKey: 'value' },
        options: [
          {
            type: 'URL',
            value: `/elephant-management/um/classifications?size=25&page=0&group=${ClassificationGroups.COMPANY}&key=${ClassificationType.KEYWORD}`,
            label: '',
            icon: null,
            index: undefined,
          },
        ],
      },
      {
        name: 'Exclude',
        type: SearchFilterType.CUSTOM_SELECT,
        icon: undefined,
        index: 1,
        layer: 3,
        exactMatch: {
          enabled: true,
          default: SearchMatchType.WORD,
        },
        key: 'exclude_products_and_services',
        field: 'exclude_products_and_services',
        metadata: {
          color: 'error',
          icon: 'block',
          preset: 'products_and_services',
          placeholder: 'Exclude Products & Services (OR) Search',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            allowCustomValuesByEnter: true,
          },
          advancedButtonVisible: true,
          dialog: {
            title: 'Bulk Exclude Product & Services',
            subTitleItemLabel: 'Product & Services',
            subTitleItemLabelPlural: 'Product & Services',
            icon: 'product-and-services',
            textArea: {
              placeholder:
                'Software Development, SaaS, Cloud Computing, Cybersecurity, ....',
            },
          },
        },
        open: true,
        utils: {
          tags: { labelFormatter: capitalize },
        },
        searchKey: 'value',
        config: { labelKey: 'value', valueKey: 'value' },
        options: [
          {
            type: 'URL',
            value: `/elephant-management/um/classifications?size=25&page=0&group=${ClassificationGroups.COMPANY}&key=${ClassificationType.KEYWORD}`,
            label: '',
            icon: null,
            index: undefined,
          },
        ],
      },
      {
        name: 'Include (AND)',
        type: SearchFilterType.CUSTOM_SELECT,
        icon: undefined,
        index: 0,
        layer: 3,
        exactMatch: {
          enabled: true,
          default: SearchMatchType.WORD,
        },
        key: 'all_of_products_and_services',
        field: 'all_of_products_and_services',
        metadata: {
          color: 'warning',
          icon: 'add-task',
          preset: 'products_and_services',
          placeholder: 'Include Products & Services (AND) Search',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            allowCustomValuesByEnter: true,
          },
          advancedButtonVisible: true,
          dialog: {
            title: 'Bulk Include (AND) Product & Services',
            subTitleItemLabel: 'Product & Services',
            subTitleItemLabelPlural: 'Product & Services',
            icon: 'product-and-services',
            textArea: {
              placeholder:
                'Software Development, SaaS, Cloud Computing, Cybersecurity, ....',
            },
          },
        },
        open: true,
        utils: {
          tags: { labelFormatter: capitalize },
        },
        searchKey: 'value',
        config: { labelKey: 'value', valueKey: 'value' },
        options: [
          {
            type: 'URL',
            value: `/elephant-management/um/classifications?size=25&page=0&group=${ClassificationGroups.COMPANY}&key=${ClassificationType.KEYWORD}`,
            label: '',
            icon: null,
            index: undefined,
          },
        ],
      },
    ],
  };
}
